/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MaterialTable from "material-table";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import ContentLoader from "react-content-loader";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Tooltip from "@tippyjs/react";

import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import DetailsContarctService from "../../../services/contract/detailsContractService";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import ViewAmortSchedules from "./AmortSchedulDetail/ViewAmortSchedules";
import AssetView from "./Asset/AssetView";
import AssetViewList from "./Asset/AssetViewList";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";
import Billing from "../../billing";
import InvoiceswithDue from "../../reports/componets/InvoiceswithDueReport";
import Keyinformation from "../Keyinformations";
import ContractShortview from "./contractshortview";
import PaymentDetails from "./Paymentdetails";
import TrialBalance from "../../Accounting/TrialBalance";
import Quote from "./Quotes";
import TransactionContractview from "../../Accounting/TransactionContract";
import Doc from "../../UploadDocument/doc";
import DocumentUpload from "../../../services/document/documentupload";
import PartyRoleContract from "../PartyRole/PartyRolecontractview";
import ContractModification from "./ContractModifications/ContractModification";
import LoanModification from "./LoanContractmodifications/LoanContractModification";
import TermConditionActiveView from "../TermsCondition/TermCondtionActiveView";
import ApprovalAction from "../../Approvals/ApprovalAction";
import ApprovalDetails from "../../Approvals/ApprovalDetails";



function ContractView({ customerPermission, setCustomData }) {
  const [planFeatures, setPlanFeatures] = useState(null);
  const [contract_number, setContract_number] = useState("");
  const [customer_name, setCustomer_Name] = useState("");
  const [start_date, setStart_date] = useState("");
  const [contract_term, setContract_term] = useState("");
  const [contract_type, setContract_type] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [status, setStatus] = useState("");
  const [financed_amount, setFinanced_amount] = useState("");
  const [iir, setIir] = useState("");
  const [totalContract, setTotalContract] = useState("");
  const [totalFinanced, setTotalFinanced] = useState("");
  const [amount_billed, setAmount_billed] = useState("");
  const [amount_unbilled, setAmount_unbilled] = useState("");
  const [amount_due, setAmount_due] = useState("");
  const [duedate, setDuedate] = useState("");
  const [nextdue_amt, setNextdue_amt] = useState("");
  const [receipt_amt, setReceipt_Amt] = useState("");
  const [nextdue_date, setNextdue_Date] = useState("");
  const [receipt_date, setReceipt_Date] = useState("");
  const [asset, setAssets] = useState("");
  const [residalcost, setResidalCost] = useState("");
  const [totalrent, setTotalRent] = useState("");
  const [deposit_amount, setDeposit_amount] = useState("");
  const [one_time_fee, setOne_time_fee] = useState("");
  const [tax_rate_rent, setTax_rate_rent] = useState("");
  const [tax_rate_fee, setTax_rate_fee] = useState("");
  const [paymentstartdate, setpaymentStartdate] = useState("");
  const [loanamount, setLoanAmount] = useState("");
  const [interestcalculationmethod, setInterestCalculationMethod] =
    useState("");
  const [repaymentprocedure, setRepaymentProcedure] = useState("");
  const [timecountingmethod, setTimeCountingMethod] = useState("");
  const [interestpostingfrequency, setInterestpostingFrequency] = useState("");
  const [paymentmethod, setPaymentMethod] = useState("");
  const [payoffamount, setTotalPayoffAmount] = useState("");
  const [invoicecount, setinvoiceCount] = useState("");
  const [itemsPayment, setItemsPayment] = useState([]);
  const [itemsAsset, setItemsAsset] = useState([]);
  // const [assethideshow, setAssetHideShow] = useState(false);
  const [contract, setConract] = useState([]);
  const [assetregcost, setAssetRegCost] = useState([]);
  const [assettaxamount, setAssetTaxamount] = useState([]);
  const [assettotalcost, setAssetTotalCost] = useState([]);
  const [assettradein, setAssetTradein] = useState([]);
  const [assetdownpayment, setAssetDownpayment] = useState([]);
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search);
  const assetId = searchParams.get('Asset');

  const [loading, setLoading] = useState(true);
  const [assetid, setassetID] = useState("");

  const { state } = useLocation();
  const [attribute, setAttribute] = useState([]);
  const [extrafiledcontract, setExtraFiled] = useState([]);
  const [key, setKey] = useState([]);
  const [display, setDisplay] = useState(false)
  const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
  const permissionsArray = permissionss.split(',');
  const [selectedTab, setSelectedTab] = useState(assetId ? 2 : 0);
  const [assetTabActivated, setAssetTabActivated] = useState(false);
  const [billToId, setBillToId] = useState('')
  const [billToIdadd, setBillToIdadd] = useState('')
  const [billTo, setBillTo] = useState([])
  const [transaction_id, setTransactionID] = useState()
  const [achPayments, setAchPayments] = useState('')
  const [achaccount, setAchAccount] = useState('')
  const [appOriginator, setAppOriginator] = useState('')
  const [source, setSource] = useState('')
  const [salesrep, setSalesRep] = useState('')
  const [subcompany, setSubCompany] = useState('')
  const [lineofbusiness, setLneOfBusiness] = useState('')
  const [interestratetype, setInterestRateType] = useState('')


  const [calu, setCalu] = useState([]);
  const [paymentdetail, setPaymentDetail] = useState([]);
  const [amortcalculation, setAmortCalculation] = useState([]);
  const [amortError, setAmortError] = useState("");
  //approval
  const [isApprovalRequired, setIsApprovalRequired] = useState(false);
  const [approvalTaskId, setApprovalTaskId] = useState(null);
  const [approvalHistory, setApprovalHistory] = useState([]);
  const [approvalRequestId, setApprovalRequestId] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState("");
  const approvalRequest = state
    ? {
      id: approvalTaskId || state,
      status: contract?.approval_status
    }
    : null;

  let navigate = useNavigate();

  const [object_name, setObject_name] = useState('Contract')

  useEffect(() => {
    const fetchSubscriptionFeatures = async () => {
      try {
        const response = await axios.get(`${API}paymentsub/subscription/`, {
          headers: authHeader()
        });

        if (response.data.success === 1 && response.data.data) {
          setPlanFeatures(response.data.data.plan);
        }
      } catch (error) {
        console.error("Error fetching subscription features:", error);
      }
    };
    fetchSubscriptionFeatures();
  }, []);
  const isDocumentsDisabled = planFeatures !== null && planFeatures.documents === false;

  useEffect(() => {
    setassetID(assetId)
  }, [assetId])

  useEffect(() => {
    if (assetId && !assetTabActivated) {
      setSelectedTab(2);
      setAssetTabActivated(true);
    }
  }, [assetId, assetTabActivated, selectedTab]);

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existcontract);
    })
  };

  useEffect(() => {
    getExtrafiled();
    DetailsContarctService.getContractDetails(state).then((response) => {
      setKey(response.data);
      setBillToId(response.data.Contract.party)
      setBillToIdadd(response.data.Contract.address)
      setContract_number(response.data.Contract.contract_number);
      setCustomer_Name(response.data.Contract.customer_name);
      setStart_date(response.data.Contract.start_date);
      setContract_term(response.data.Contract.contract_term);
      setContract_type(response.data.Contract.contract_type);
      setEnd_date(response.data.Contract.end_date);
      setStatus(response.data.Contract.status);
      setFinanced_amount(response.data.Contract.financed_amount);
      setConract(response.data.Contract);
      setReceipt_Amt(response.data.receipt_amt);
      setReceipt_Date(response.data.receipt_date);
      setAssets(response.data.Assets);
      setIir(response.data.irr);
      setResidalCost(response.data.residalvalue);
      setTotalContract(response.data.totalContract);
      setAmount_billed(response.data.amount_billed);
      setAmount_unbilled(response.data.amount_unbilled);
      setNextdue_amt(response.data.nextdue_amt);
      setNextdue_Date(response.data.nextdue_date);
      setAmount_due(response.data.amount_due);
      setDuedate(response.data.duedata);
      setTotalRent(response.data.totalRent);
      setDeposit_amount(response.data.Contract.deposit_amount);
      setOne_time_fee(response.data.Contract.one_time_fee);
      setTax_rate_rent(response.data.Contract.tax_rate_rent);
      setTax_rate_fee(response.data.Contract.tax_rate_fee);
      setTotalFinanced(response.data.totalFinanced);
      setpaymentStartdate(response.data.Contract.paymentstartdate);
      setLoanAmount(response.data.Contract.loanamount);
      setInterestCalculationMethod(
        response.data.Contract.interestcalculationmethod
      );
      setRepaymentProcedure(response.data.Contract.repaymentprocedure);
      setTimeCountingMethod(response.data.Contract.timecountingmethod);
      setInterestpostingFrequency(
        response.data.Contract.interestpostingfrequency
      );
      setPaymentMethod(response.data.Contract.paymentrule);
      setAssetDownpayment(response.data.downpayment);
      setAssetRegCost(response.data.registrationcost);
      setAssetTaxamount(response.data.taxamount);
      setAssetTotalCost(response.data.totalcost);
      setAssetTradein(response.data.tardein);
      setTotalPayoffAmount(response.data.totalpayoff);
      setinvoiceCount(response.data.invoicecount);
      setAchPayments(response.data.Contract.enable_ach);
      setAchAccount(response.data.Contract.ach_account);
      setAppOriginator(response.data.Contract.appOriginator);
      setSalesRep(response.data.Contract.salesRep);
      setSource(response.data.Contract.source);
      setSubCompany(response.data.Contract.subcompany_name);
      setLneOfBusiness(response.data.Contract.line_of_business_name);
      setInterestRateType(response.data.Contract.interest_rate_type);
      setAttribute([
        { attribute: response.data.Contract.contractattribute1 },
        { attribute: response.data.Contract.contractattribute2 },
        { attribute: response.data.Contract.contractattribute3 },
        { attribute: response.data.Contract.contractattribute4 },
        { attribute: response.data.Contract.contractattribute5 },
        { attribute: response.data.Contract.contractattribute6 },
        { attribute: response.data.Contract.contractattribute7 },
        { attribute: response.data.Contract.contractattribute8 },
        { attribute: response.data.Contract.contractattribute9 },
        { attribute: response.data.Contract.contractattribute10 },
        { attribute: response.data.Contract.contractattribute11 },
        { attribute: response.data.Contract.contractattribute12 },
        { attribute: response.data.Contract.contractattribute13 },
        { attribute: response.data.Contract.contractattribute14 },
        { attribute: response.data.Contract.contractattribute15 },
      ]);
      setLoading(false);
    })
    // ✅ Approval History
    axios.get(API + `approvals/history/${state}/`, {
      headers: authHeader(),
      params: { type: "contract" }
    })
      .then(res => setApprovalHistory(res.data || []))
      .catch(() => setApprovalHistory([]));

    // ✅ Approval Task
    axios.get(API + `approvals/task/${state}/?type=contract`, {
      headers: authHeader()
    })
      .then(res => {
        setApprovalTaskId(res.data.task_id);
        setApprovalRequestId(res.data.request_id);
        setApprovalStatus(res.data.status);
      });
  }, [state]);



  useEffect(() => {
    axios.get(API + "accounting/transactiontypesview/?", {
      headers: authHeader()
    })
      .then(res => {
        console.log("API DATA:", res.data);

        // ✅ FIX 1: correct data path
        const transactionList = res.data.data || [];

        console.log("Transaction List:", transactionList);

        // ✅ FIX 2: correct find condition
        const activation = transactionList.find(
          (item) =>
            item.transaction_type === "Activation" ||
            item.description === "Activation"
        );

        console.log("FINAL Activation:", activation);

        if (activation) {
          const approvalFlag = (activation.approval || "")
            .trim()
            .toUpperCase();

          setIsApprovalRequired(approvalFlag === "Y");
        } else {
          console.warn("Activation NOT FOUND");
        }
      })
      .catch(err => {
        console.error("API ERROR:", err);
      });
  }, []);


  const handleApprovalSuccess = async (actionType) => {
    if (actionType !== "approve") {
      // Non-approve actions (submit / reject / reassign) → just refresh
      window.location.reload();
      return;
    }

    try {
      let activateUrl = "";
      let items = [];
      let amort = [];

      if (contract_type === "Loan") {
        // LOAN 
        activateUrl = `contracts/contractloan-activate/${state}/`;

        const payRes = await axios.get(
          `${API}contracts/paymentScheduleCalculation/?id=${state}`,
          { headers: authHeader() }
        );
        items = payRes.data.response;

        // Loan amort: amortCalculation API
        const amortRes = await axios.get(
          `${API}contracts/amortCalculation/?id=${state}`,
          { headers: authHeader() }
        );
        amort = amortRes.data.response;

      } else if (contract_type === "Rental") {
        // RENTAL 
        activateUrl = `contracts/contractrental-activate/${state}/`;
        const payRes = await axios.get(
          `${API}contracts/payment-view/${state}/`,
          { headers: authHeader() }
        );
        const payData = payRes.data;

        // Rental items: payment-view + Helper.calculatePaymentDates
        items = Helper.calculatePaymentDates(
          start_date,
          contract.paymentrule,
          payData.length,
          contract.paymentfrequency,
          contract.contract_term,
          payData,
          []
        );

        let rentAmounts = [];
        let rentalAmounts = [];
        let sumofNoofpayment = 0;
        const payFreq = contract.paymentfrequency;
        const payRule = contract.paymentrule;

        payData.forEach((rentItem) => {
          if (rentItem.payment_type === "Rent") {
            sumofNoofpayment += rentItem.no_of_payments;

            let interval;
            switch (payFreq) {
              case "Quarterly": interval = 3; break;
              case "Semi-annual": interval = 6; break;
              case "Annual": interval = 12; break;
              default: interval = 1;  // Monthly
            }

            if (payRule === "Advance") {
              for (let i = 0; i < rentItem.no_of_payments * interval; i++) {
                if (i % interval === 0) {
                  rentAmounts.push(rentItem.amount);
                  rentalAmounts.push(rentItem.amount);
                } else {
                  rentAmounts.push(0);
                  rentalAmounts.push(rentItem.amount);
                }
              }
            } else {
              for (let i = 0; i < rentItem.no_of_payments * interval; i++) {
                if ((i + 1) % interval === 0) {
                  rentAmounts.push(rentItem.amount);
                  rentalAmounts.push(rentItem.amount);
                } else {
                  rentAmounts.push(0);
                  rentalAmounts.push(rentItem.amount);
                }
              }
            }
          }
        });


        let numberofpayment;
        switch (payFreq) {
          case "Monthly": numberofpayment = sumofNoofpayment; break;
          case "Quarterly": numberofpayment = sumofNoofpayment * 3; break;
          case "Annual": numberofpayment = sumofNoofpayment * 12; break;
          case "Semi-annual": numberofpayment = sumofNoofpayment * 6; break;
          default: numberofpayment = sumofNoofpayment;
        }

        if (payRule === "Advance") {
          amort = Helper.generateRentalAdvanceAmortSchedule(
            start_date,
            numberofpayment,
            financed_amount,
            rentAmounts,
            payFreq,
            iir,
            residalcost,
            rentalAmounts
          );
        } else {
          amort = Helper.generateRentalArrearsSchedule(
            start_date,
            numberofpayment,
            financed_amount,
            rentAmounts,
            payFreq,
            iir,
            residalcost,
            rentalAmounts
          );
        }

      } else {
        // LEASE 
        activateUrl = `contracts/contract-activate/${state}/`;

        // Lease items: payment-view + Helper.calculatePaymentDates
        const payRes = await axios.get(
          `${API}contracts/payment-view/${state}/`,
          { headers: authHeader() }
        );
        items = Helper.calculatePaymentDates(
          start_date,
          contract.paymentrule,
          payRes.data.length,
          contract.paymentfrequency,
          contract.contract_term,
          payRes.data,
          []
        );

        // Lease amort: amortCalculation API
        const amortRes = await axios.get(
          `${API}contracts/amortCalculation/?id=${state}`,
          { headers: authHeader() }
        );
        amort = amortRes.data.response;
      }

      // Call the correct activation endpoint with proper items + amort
      await axios.post(
        API + activateUrl,
        { items, amort },
        { headers: authHeader() }
      );

      toast.success("Contract activated successfully!");
      setTimeout(() => window.location.reload(), 1500);

    } catch (err) {
      console.error(err);
      toast.error("Failed to activate contract");
    }
  };





  const handlePaymentDetailViewForEntered = async () => {
    if (status !== "Entered") return;

    try {
      let url = API + "contracts/payment-view/" + state + "/";

      const response = await axios.get(url, { headers: authHeader() });

      const paymentData = response.data;

      setCalu([]);
      const calculatedData = Helper.calculatePaymentDates(
        start_date,
        contract.paymentrule,
        paymentData.length,
        contract.paymentfrequency,
        contract.contract_term,
        paymentData,
        []
      );

      setPaymentDetail(calculatedData);

      // ✅ debug logs
      console.log("Entered Status - Payment API:", paymentData);
      console.log("Entered Status - Calculated:", calculatedData);

    } catch (error) {
      console.error("Error in Entered Payment Logic:", error);
    }
  };

  const handleAmortizationForEntered = async () => {
    if (status !== "Entered") return;

    try {
      // reset
      setCalu([]);
      setAmortCalculation([]);

      if (!paymentdetail || paymentdetail.length === 0) {
        console.log("No payment detail, skipping amortization");
        return;
      }

      const response = await axios.get(
        `${API}contracts/amortCalculation/?id=${state}`,
        { headers: authHeader() }
      );

      const amortData = response.data.response;
      const amortErrorMsg = response.data.errors || "";

      // set state
      setCalu(amortData);
      setAmortCalculation(amortData);
      setAmortError(amortErrorMsg);

      // console logs
      console.log("Entered - Amortization Data:", amortData);
      console.log("Entered - Amortization Error:", amortErrorMsg);

    } catch (error) {
      console.error("Error in amortization:", error);
    }
  };

  useEffect(() => {
    if (status === "Entered") {
      handlePaymentDetailViewForEntered();
    }
  }, [status]);


  useEffect(() => {
    if (
      status === "Entered" &&
      paymentdetail &&
      paymentdetail.length > 0
    ) {
      handleAmortizationForEntered();
    }
  }, [status, paymentdetail]);










  console.log('interestratetype', interestratetype)

  const handelDefault1 = () => {
    let url = API + "contracts/asset-view/" + state + "/";
    axios
      .get(url, { headers: authHeader() })
      .then((response) => setItemsAsset(response.data.data))
  };

  const handelDefault = () => {
    let url = API + "contracts/payment-view/" + state + "/";
    axios
      .get(url, { headers: authHeader() })
      .then((response) => setItemsPayment(response.data))
  };

  const handlePartyView = (id) => {
    navigate("/party/details", { state: id });
  };

  useEffect(() => {
    handelDefault();
    handelDefault1();
  }, []);
  const [viewInvoice, setviewInvoice] = useState("invoice");
  const [invoice, setInvoice] = useState(false);
  const [invoicewithdue, setInvoicewithdue] = useState(false);

  const [contract_modification, setContract_modification] = useState("PayoffQuote")
  const [newTerm, setNewTerm] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    viewInvoice === "invoice" ? setInvoice(true) : setInvoice(false);
    viewInvoice === "invoicewithdue"
      ? setInvoicewithdue(true)
      : setInvoicewithdue(false);
  }, [viewInvoice]);

  const handelOnChange = (e) => {
    setviewInvoice(e.target.value);
  };

  const handelOnChangeContract = (e) => {
    setContract_modification(e.target.value)
  }

  const handleNewTermChange = (e) => {
    const value = e.target.value;
    if (value && parseInt(value) < parseInt(contract.contract_term)) {
      setError("New Term should not be less than Current Term.");
    } else {
      setError("");
    }
    setNewTerm(value);
  };

  const handleTabClick = (index) => {
    setSelectedTab(index);
  };

  useEffect(() => {
    setCustomData({
      object_id: state,
      object_name: object_name
    })
  }, [object_name, setCustomData, state])

  const getaddress = async () => {
    if (billToId !== '') {
      const resst = await fetch(
        API +
        "parties/manage-address/" +
        billToId +
        "/?address_type=bill_to",
        { headers: authHeader() }
      );
      const getst = await resst.json();
      const address = getst.data && getst.data.filter((val) => val.id === billToIdadd)
      setBillTo(address);
    }
  };

  useEffect(() => {
    getaddress()
  }, [billToId, billToIdadd])


  const [currentPage, setCurrentPage] = useState(1);
  const [documents, setDocuments] = useState([]);

  const recordsPerPage = 2;
  let indexOfLastRecord, indexOfFirstRecord, currentDocuments, totalPages;
  if (customerPermission !== 'Customer') {
    indexOfLastRecord = currentPage * recordsPerPage;
    indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    currentDocuments = documents.slice(indexOfFirstRecord, indexOfLastRecord);
    totalPages = Math.ceil(documents.length / recordsPerPage);
  } else {
    currentDocuments = documents;
  }

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  useEffect(() => {
    DocumentUpload.viewListuploadFilterview("contract", state).then((res) => {
      setDocuments(res.data.data)
    }).catch((e) => {
      console.log('e', e)
    })
  }, [contract_number, state]);

  const handleDownload = (fileUrl) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUpload = () => {
    navigate('/doc', {
      state: {
        reference_id: state,
        reference_name: contract_number
      }
    });
  }

  return (
    <>
      <div className="container-fluid" style={{ overflow: "hidden" }}>
        {loading === false ? (
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-md-12">
              <div className="mb-0">
                <div className="header pb-0 mb-2">
                  <div className="d-lg-flex">
                    <div>
                      <h5 className="mb-0 pt-3">{t("Contract")}</h5>
                      <h6>
                        <Link to="/contract" className="tc">
                          {t("Contracts")}
                        </Link>{" "}
                        / <span>{t("View Contract")}</span>
                      </h6>
                    </div>
                  </div>
                </div>
                <Tabs defaultIndex={selectedTab} selectedIndex={selectedTab} onSelect={(index) => setSelectedTab(index)}>
                  <TabList>
                    <Tab onClick={() => handleTabClick(0)} selected={selectedTab === 0}>
                      <p>{t("Contract Details")}</p>
                    </Tab>
                    <Tab onClick={() => handleTabClick(1)} selected={selectedTab === 1}>
                      <p>{t("Party Role")}</p>
                    </Tab>
                    <Tab onClick={() => handleTabClick(2)} selected={selectedTab === 2}>
                      <p>{t("Terms & Conditions")}</p>
                    </Tab>
                    <Tab onClick={() => handleTabClick(3)} selected={selectedTab === 3}>
                      <p>{t("Payment Schedules")}</p>
                    </Tab><Tab onClick={() => handleTabClick(4)} selected={selectedTab === 4}>
                      {/* <p>{t("Assets")}</p> */}
                      <p>{contract_type === 'Loan' ? t("Collateral Details") : t("Assets")}</p>
                    </Tab>
                    {customerPermission !== 'Customer' && status !== "Entered" &&
                      <>
                        <Tab onClick={() => handleTabClick(5)} selected={selectedTab === 5}>
                          <p onClick={() => setDisplay(true)}>{t("Amort Schedules")}</p>
                        </Tab>
                        <Tab onClick={() => handleTabClick(6)} selected={selectedTab === 6}>
                          <p>{t("Invoices")}</p>
                        </Tab>
                        <Tab onClick={() => handleTabClick(7)} selected={selectedTab === 7}>
                          <p>{t("Transactions")}</p>
                        </Tab><Tab onClick={() => handleTabClick(8)} selected={selectedTab === 8}>
                          <p>{t("Accounting Entries")}</p>
                        </Tab>
                        {
                          permissionsArray.includes('view_quoteheader') &&
                          <Tab onClick={() => handleTabClick(9)} selected={selectedTab === 9}>
                            {/* <p>{t("Payoff Quotes")}</p> */}
                            <p>{t("Contract Modification")}</p>
                          </Tab>
                        }
                      </>
                    }
                  </TabList>
                  <TabPanel>
                    <div
                      className="panel-content"
                      style={{ paddingLeft: "10px" }}
                    >
                      <ToastContainer />
                      <div className="header  mb-3 pb-0 d-flex align-items-center justify-content-between">
                        {/* <div className="pt-2"> */}
                        {/* <div className="col-xl-6"> */}
                        <h5 className="mb-3  text-md-start">{t("Contract Details")}</h5>
                      </div>
                      <div className="col-md-12">
                        <div className='d-flex flex-column flex-lg-row'>
                          <div className="col-12 col-lg-7">
                            <div className="card h-100">
                              <div className="card-body">
                                {/* <div className="col-md-10"> */}
                                <div className="row">
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className="col-form-label">
                                      {t("Sub Company")}{" "}
                                      <Tooltip
                                        content={t("Subcompany_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className="view-label p">
                                        {subcompany
                                          ?
                                          subcompany

                                          : "None"}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className="col-form-label">
                                      {t("Line of Business")}{" "}
                                      <Tooltip
                                        content={t("Lineofbusiness_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className="view-label p">
                                        {lineofbusiness
                                          ?
                                          lineofbusiness

                                          : "None"}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className="col-form-label">
                                      {t("Contract Number")}{" "}
                                      <Tooltip content={t("Contract_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className="view-label p">
                                        {contract_number}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className="col-form-label">
                                      {t("Contract Type")}{" "}
                                      <Tooltip content={t("ContractType_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className="view-label p">
                                        {contract_type}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className=" row">
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className="col-form-label">
                                      {t("Customer")}{" "}
                                      <Tooltip content={t("Customer_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span
                                        className={`view-label p  ${customerPermission !== 'Customer' && 'hyperlink'}`}
                                        onClick={() =>
                                          permissionsArray.includes("view_party") === true &&
                                            customerPermission !== 'Customer'
                                            ? handlePartyView(contract.party) : null
                                        }
                                      >
                                        {customer_name}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className="col-form-label">
                                      {t("Status")}{" "}
                                      <Tooltip content={t("Status_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className="view-label p">
                                        {status}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className=" row">
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className=" col-form-label">
                                      {t("Start Date")}{" "}
                                      <Tooltip content={t("StartDate_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className=" view-label p">
                                        {Helper.DateNormal(start_date)}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className="col-form-label">
                                      {t("End Date")}{" "}
                                      <Tooltip content={t("EndDate_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className="view-label p">
                                        {Helper.DateNormal(end_date)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  {contract_type === "Loan" ? (
                                    <>
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                          {t("Payment Start Date")}{" "}
                                          <Tooltip
                                            content={t("PaymentStartDate_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className="view-label p">
                                            {paymentstartdate
                                              ? Helper.DateNormal(paymentstartdate)
                                              : "None"}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                          {t("Loan Amount")}{" "}
                                          <Tooltip
                                            content={t("LoanAmount_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className="view-label p">
                                            {loanamount
                                              ? Helper.Amount(
                                                loanamount - deposit_amount
                                              )
                                              : "None"}
                                          </span>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className=" row">
                                  {
                                    contract_type === "Loan" ?
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                          {/* {t("Contract Exposure")}{" "} */}
                                          {t("Loan Principal")}{" "}
                                          <Tooltip content={t("LoanPrincipal_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className=" view-label p">
                                            {
                                              status === "Active" ?

                                                contract_type === "Rental" ?
                                                  (
                                                    // Helper.Amount(contractdetail.totalRent * contractdetail.Contract.contract_term + contractdetail.residalvalue)
                                                    Helper.Amount(key.amount_billed_not_paid)
                                                  )
                                                  :
                                                  (
                                                    Helper.Amount(key.amount_billed_not_paid + key.total_capital_recovery)
                                                  )
                                                : 0.00
                                            }
                                          </span>
                                        </div>
                                      </div> :
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                          {/* {t("Contract Exposure")}{" "} */}
                                          {t("Net Investment")}{" "}
                                          <Tooltip content={t("NetInvestment_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className=" view-label p">
                                            {
                                              status === "Active" ?

                                                contract_type === "Rental" ?
                                                  (
                                                    // Helper.Amount(contractdetail.totalRent * contractdetail.Contract.contract_term + contractdetail.residalvalue)
                                                    Helper.Amount(key.amount_billed_not_paid)
                                                  )
                                                  :
                                                  (
                                                    Helper.Amount(key.amount_billed_not_paid + key.total_capital_recovery)
                                                  )
                                                : 0.00
                                            }
                                          </span>
                                        </div>
                                      </div>
                                  }
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className=" col-form-label">
                                      {t("Bill To")}{" "}
                                      <Tooltip content={t("StartDate_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      {billTo && billTo.map((address, index) => {
                                        const addressParts = [
                                          address.address_line_1,
                                          address.address_line_2,
                                          address.city,
                                          address.country
                                        ].filter(part => part && part !== 'null' && part !== '');
                                        return (
                                          <span className=" view-label p">
                                            {addressParts.join(', ')}
                                          </span>
                                        );
                                      })}
                                    </div>
                                  </div>
                                  {/* </div> */}
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className="col-form-label">
                                      {t("Ach Payments")}{" "}
                                      <Tooltip
                                        content={t("achpayments_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className="view-label p">
                                        {achPayments
                                          ?
                                          achPayments === 'Y' ? 'Yes' : 'No'

                                          : "None"}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className="col-form-label">
                                      {t("Bank Account")}{" "}
                                      <Tooltip
                                        content={t("bankaccount_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className="view-label p">
                                        {achaccount
                                          ?
                                          achaccount

                                          : "None"}
                                      </span>
                                    </div>
                                  </div>
                                  {/* </div> */}
                                  {/* <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                          {t("Application Originator")}{" "}
                                          <Tooltip
                                            content={t("ApplicationOrginator_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className="view-label p">
                                            {appOriginator
                                              ? 
                                                appOriginator
                                            
                                              : "None"}
                                          </span>
                                        </div>
                                        </div>
                                 <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                          {t("Source")}{" "}
                                          <Tooltip
                                            content={t("source_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className="view-label p">
                                            {source
                                              ? 
                                                source
                                            
                                              : "None"}
                                          </span>
                                        </div>
                                        </div>
                                        */}
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <label className="col-form-label">
                                      {t("Sales Rep")}{" "}
                                      <Tooltip
                                        content={t("SalesRep_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className="view-label p">
                                        {salesrep
                                          ?
                                          salesrep

                                          : "None"}
                                      </span>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                          {customerPermission !== 'Customer' && !isDocumentsDisabled && (
                            <div className="col-12 col-lg-5">
                              <div className="card">
                                <div className="card-body">
                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0">Documents ({documents.length})</h5>
                                    <button className="btn btn-primary btn-sm btn-md-normal" onClick={handleUpload}>UPLOAD</button>
                                  </div>

                                  <div className="documents-list">
                                    {currentDocuments && currentDocuments.length > 0 ? (
                                      <>
                                        {currentDocuments && currentDocuments.map(doc => (
                                          <div className="document-item" key={doc.id}>
                                            <div className="document-icon">
                                              {doc.type === 'pdf' ? '📄' :
                                                doc.type === 'doc' || doc.type === 'docx' ? '📝' :
                                                  doc.type === 'jpg' || doc.type === 'jpeg' || doc.type === 'png' ? '🖼️' :
                                                    '📁'}
                                            </div>
                                            <div className="document-info">
                                              <div className="document-name">{doc.title}</div>
                                              <div className="document-metadata">
                                                {Helper.DateNormal(doc.uploaded_at)}
                                              </div>
                                              <div className="document-tags">
                                                {doc.tags.split(',').map((tag, index, arr) => (
                                                  <span key={index} className="tag-pill">{tag.trim()}{index < arr.length - 1 ? ', ' : ''}</span>
                                                ))}
                                              </div>
                                            </div>
                                            <div className="document-actions">
                                              <button className="btn-continue border-0 btn btn-primary btn-gradient-primary btn"
                                                onClick={() => handleDownload(doc.file)}
                                              >
                                                Download
                                              </button>
                                            </div>
                                          </div>
                                        ))}

                                        <div className="pagination-controls d-flex justify-content-between align-items-center mt-3">
                                          <button
                                            className="pag-btn btn btn-outline-secondary btn-sm"
                                            onClick={handlePrevious}
                                            disabled={currentPage === 1}
                                          >
                                            Previous
                                          </button>

                                          <span className="small">Page {currentPage} of {totalPages}</span>

                                          <button
                                            className="pag-btn btn btn-outline-secondary btn-sm"
                                            onClick={handleNext}
                                            disabled={currentPage === totalPages}
                                          >
                                            Next
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <div className="text-center py-4">
                                        <p className="text-muted">No documents available</p>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {isApprovalRequired && (
                                <div className="card mt-3">

                                  {approvalStatus === "approved" || approvalStatus === "rejected" ? (
                                    <ApprovalDetails
                                      approvalHistory={approvalHistory}
                                      approvalRequestId={approvalRequestId}
                                    />
                                  ) : (
                                    approvalRequest && (
                                      <ApprovalAction
                                        request={approvalRequest}
                                        onSuccess={handleApprovalSuccess}
                                      />
                                    )
                                  )}

                                </div>
                              )}

                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        className="accordion mb-4 pt-4 "
                        id="accordionFlushExample"
                      >
                        <div className="accordion-item">
                          <h2
                            className="accordion-header"
                            id="panelsStayOpen-headingthree"
                          >
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              style={{ color: "#008DC1" }}
                              data-bs-toggle="collapse"
                              data-bs-target="#panelsStayOpen-collapseThree"
                              aria-expanded="false"
                              aria-controls="panelsStayOpen-collapseThree"
                            >
                              <b>{t("Assets Summary")}</b>
                            </button>
                          </h2>
                          <div
                            id="panelsStayOpen-collapseThree"
                            className="accordion-collapse collapse "
                            aria-labelledby="panelsStayOpen-headingThree"
                          >
                            <div className="accordion-body">
                              <div className="col-md-12">
                                <div className="">
                                  <div className="col ">
                                    <div className="col text-right"></div>
                                  </div>
                                  <div className="card-body">
                                    <div className=" row">
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                          {t("No. of Assets")}{" "}
                                          <Tooltip
                                            content={t(
                                              "NumberofAssets_Tooltip"
                                            )}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className="view-label p">
                                            {asset}
                                          </span>
                                        </div>
                                      </div>
                                      {/* </div> */}
                                      {/* <div className=" row"> */}
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                          {t("Registration Cost")}{" "}
                                          <Tooltip
                                            content={t("Registration_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className="view-label p">
                                            {Helper.Amount(assetregcost)}
                                          </span>
                                        </div>
                                      </div>
                                      {/* </div> */}
                                      {contract_type !== 'Loan' &&
                                        // <div className=" row">
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <label className="col-form-label">
                                            {t("Residual Value")}{" "}
                                            <Tooltip content={t("ResidualValue_Tooltip")}>
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                            <span className="view-label p">
                                              {Helper.Amount(residalcost)}
                                            </span>
                                          </div>
                                        </div>
                                        // </div>
                                      }
                                      {/* <div className=" row"> */}
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                          {t("Tax Amount")}{" "}
                                          <Tooltip content={t("Tax_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className="view-label p">
                                            {Helper.Amount(assettaxamount)}
                                          </span>
                                        </div>
                                      </div>
                                      {/* </div> */}
                                      {/* <div className=" row"> */}
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                          {t("Total Cost")}{" "}
                                          <Tooltip
                                            content={t("TotalCost_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className="view-label p">
                                            {Helper.Amount(assettotalcost)}
                                          </span>
                                        </div>
                                      </div>
                                      {/* </div> */}
                                      {/* <div className=" row"> */}
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className=" col-form-label">
                                          {t("Trade In")}{" "}
                                          <Tooltip
                                            content={t("TradeIn_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className=" view-label p">
                                            {Helper.Amount(assettradein)}
                                          </span>
                                        </div>
                                      </div>
                                      {/* </div> */}
                                      {/* <div className=" row"> */}
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <label className="col-form-label">
                                          {t("Down Payment")}{" "}
                                          <Tooltip
                                            content={t("DownPayment_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                          <span className="view-label p">
                                            {Helper.Amount(assetdownpayment)}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Keyinformation
                        contractdetail={key}
                        extrafiledcontractdetail={extrafiledcontract}
                        customerPermission={customerPermission}
                      ></Keyinformation>
                      <div className="accordion-item ">
                        <h2
                          className="accordion-header"
                          id="panelsStayOpen-headingFive"
                        >
                          <button
                            className="accordion-button collapsed"
                            style={{ color: "#008DC1" }}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseFive"
                            aria-expanded="false"
                            aria-controls="panelsStayOpen-collapseFive"
                          >
                            <b>{t("Calculation Details")}</b>
                          </button>
                        </h2>
                        <div
                          id="panelsStayOpen-collapseFive"
                          className="accordion-collapse collapse"
                          aria-labelledby="panelsStayOpen-headingFive"
                        >
                          <div className="accordion-body">
                            <div className="col-md-12">
                              <div className="">
                                <div className="col ">
                                  <div className="col text-right"></div>
                                </div>
                                <div className="card-body">
                                  <div className=" row">
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <label className=" col-form-label">
                                        {t("Interest Calculation Method")}{" "}
                                        <Tooltip
                                          content={t(
                                            "InterestCalculationMethod_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <span className=" view-label p">
                                          Simple
                                        </span>
                                      </div>
                                    </div>
                                    {/* </div> */}
                                    {/* <div className=" row"> */}
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <label className="col-form-label">
                                        {t("Repayment Procedure")}{" "}
                                        <Tooltip
                                          content={t(
                                            "RepaymentProcedure_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <span className=" view-label p">
                                          Standard
                                        </span>
                                      </div>
                                    </div>
                                    {/* </div> */}
                                    {/* <div className=" row"> */}
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <label className="col-form-label">
                                        {t("Time Counting Method")}{" "}
                                        <Tooltip
                                          content={t(
                                            "TimeCountingMethod_Tooltip"
                                          )}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <span className="view-label p">
                                          {timecountingmethod
                                            ? timecountingmethod
                                            : '30/360'}
                                        </span>
                                      </div>
                                    </div>
                                    {/* </div> */}
                                    {/* <div className=" row"> */}
                                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <label className="col-form-label">
                                        {t("Payment Method")}{" "}
                                        <Tooltip
                                          content={t("PaymentMethod_Tooltip")}
                                        >
                                          <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                      </label>
                                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                        <span className="view-label p">
                                          {contract_type === "Lease"
                                            ? "Advance"
                                            : paymentmethod
                                              ? paymentmethod
                                              : "None"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div
                      className="panel-content"
                      style={{ paddingLeft: "10px" }}
                    >
                      <ContractShortview contract={contract} customerPermission={customerPermission} TotalIncome={key.total_income} iir={iir} netinvest={key.amount_billed_not_paid} Loanpricipal={key.amount_billed_not_paid + key.total_capital_recovery} />
                      <div className="mt-2 mb-2" >
                        <PartyRoleContract
                          id={state}
                          contracttype={contract_type}
                        // setTab={tabcontractIndex}
                        // party_id={customer_id}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div
                      className="panel-content"
                      style={{ paddingLeft: "10px" }}
                    >
                      <ContractShortview contract={contract} customerPermission={customerPermission} TotalIncome={key.total_income} iir={iir} netinvest={key.amount_billed_not_paid} Loanpricipal={key.amount_billed_not_paid + key.total_capital_recovery} />
                      <div className="mt-2 mb-2" >
                        <TermConditionActiveView
                          contract_id={state}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div
                      className="panel-content"
                      style={{ paddingLeft: "7px" }}
                    >
                      <ContractShortview contract={contract} customerPermission={customerPermission} TotalIncome={key.total_income} iir={iir} display={display} netinvest={key.amount_billed_not_paid} Loanpricipal={key.amount_billed_not_paid + key.total_capital_recovery} />
                      <div className="row" id="payschedule">
                        <div className="col-md-12">
                          <div className="">
                            <div className="header pb-0 pt-2">
                              <div className="d-lg-flex">
                                <div>
                                  <h5 className="mb-3">
                                    {t("Payment Schedules")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                            {/* <div className="row mb-3">
                              <div className="col-xl-3">
                                <div className="card">
                                  <div className="form-group row ">
                                    <label className="col-lg-12 col-form-label">
                                      {t("Deposit Amount")}{" "}
                                      <Tooltip
                                        content={t("DepositAmount_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-lg-8 view-label p">
                                      {Helper.Amount(deposit_amount)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-xl-3">
                                <div className="card">
                                  <div className="form-group row">
                                    <label className="col-lg-12 col-form-label">
                                      {t("Fees (One-Time)")}{" "}
                                      <Tooltip
                                        content={t("Fees-Onetime_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-lg-8 view-label p">
                                      {Helper.Amount(one_time_fee)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-xl-3">
                                <div className="card">
                                  <div className="form-group row">
                                    <label className="col-lg-12 col-form-label">
                                      {t("Tax Rate (Rent)")}{" "}
                                      <Tooltip
                                        content={t("TaxRate-Rent_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-lg-8 view-label p">
                                      {Helper.Amount(tax_rate_rent)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-xl-3">
                                <div className="card">
                                  <div className="form-group row">
                                    <label className="col-lg-12 col-form-label">
                                      {t("Tax Rate (Fee)")}{" "}
                                      <Tooltip
                                        content={t("TaxRate-Fee_Tooltip")}
                                      >
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-lg-8 view-label p">
                                      {Helper.Amount(tax_rate_fee)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </div>
                        <div className="body">
                          <div className="table-responsive">
                            {contract_type === "Loan" ? (
                              <MaterialTable
                                style={{
                                  backgroundColor: "var(--bs-table-bg)",
                                  borderBottomWidth: "1px",
                                  boxShadow:
                                    "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                }}
                                columns={[
                                  {
                                    title: `${t("Periods")}`,
                                    field: "periods",
                                    render: (rowData) => (
                                      <>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Periods")}</div>
                                        <div>{(rowData.periods)}</div>
                                      </>
                                    ),
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    },
                                    cellStyle: {
                                      textAlign: "left",
                                      fontSize: 12,
                                    },
                                  },
                                  {
                                    title: `${t("Payment Type")}`,
                                    field: "payment_type",
                                    render: (rowData) =>
                                      <>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Payment Type")}</div>
                                        {/* <div>{
                                          rowData.payment_type === null
                                            ? "Rent"
                                            : rowData.payment_type}</div> */}
                                        <div>{
                                          rowData.payment_type === null || rowData.payment_type === "Rent"
                                            ? (contract_type === "Loan" ? "Payment" : "Rent")
                                            : rowData.payment_type}
                                        </div>
                                      </>,
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    },
                                    cellStyle: {
                                      textAlign: "left",
                                      fontSize: 12,
                                    },
                                    // hidden:contract.contract_type === 'Loan' ? true : false
                                  },
                                  {
                                    title: `${t("Payment Amount")}`,
                                    field: "amount",
                                    render: (rowData) =>
                                      <>
                                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                        >{t("Payment Amount")}</div>
                                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                          {Helper.Amount(rowData.amount)}</div></>,
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "right",
                                    },
                                    // cellStyle: {
                                    //   textAlign: "right",
                                    //   fontSize: 12,
                                    // },
                                  },
                                  {
                                    title: `${t("Frequency")}`,
                                    field: "frequency",
                                    render: (rowData) =>
                                      <>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Frequency")}</div>
                                        <div>
                                          {(rowData.frequency)}</div></>,
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    },
                                    cellStyle: {
                                      textAlign: "left",
                                      fontSize: 12,
                                    },
                                  },
                                  {
                                    title: `${t("Start Date")}`,
                                    field: "start_date",
                                    render: (rowData) =>
                                      <>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Start Date")}</div>
                                        <div>
                                          {Helper.DateNormal(rowData.start_date)}</div></>,
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    },
                                    cellStyle: {
                                      textAlign: "left",
                                      fontSize: 12,
                                    },
                                  },
                                  {
                                    title: `${t("End Date")}`,
                                    field: "end_date",
                                    render: (rowData) =>
                                      <>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("End Date")}</div>
                                        <div>
                                          {Helper.DateNormal(rowData.end_date)}</div></>,
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    },
                                    cellStyle: {
                                      textAlign: "left",
                                      fontSize: 12,
                                    },
                                  },
                                ]}
                                data={itemsPayment}
                                options={{
                                  headerStyle: {
                                    backgroundColor: "white",
                                    color: "#245C7F",
                                    // color: "#008DC1",
                                    fontSize: 12,
                                  },
                                  rowStyle: (rowData, index) => {
                                    if (index % 2) {
                                      return { backgroundColor: "#fff" };
                                    }
                                  },
                                  sorting: true,
                                  search: false,
                                  toolbar: false,
                                  paging: true,
                                  pageSize: 3, // make initial page size
                                  emptyRowsWhenPaging: false, // To avoid of having empty rows
                                  pageSizeOptions: [3, 15, 20, 50],
                                  paginationType: "stepped",
                                  showFirstLastPageButtons: false,
                                  actionsColumnIndex: -1,
                                }}
                              />
                            ) : (
                              <MaterialTable
                                style={{
                                  backgroundColor: "var(--bs-table-bg)",
                                  borderBottomWidth: "1px",
                                  boxShadow:
                                    "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                }}
                                columns={[
                                  {
                                    title: `${t("No. Of Payments")}`,
                                    field: "no_of_payments",
                                    render: (rowDate) =>
                                      <>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("No. Of Payments")}</div>
                                        <div>
                                          {(rowDate.no_of_payments)}
                                        </div></>,
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    },
                                    cellStyle: {
                                      textAlign: "left",
                                      fontSize: 12,
                                    },
                                  },
                                  {
                                    title: `${t("Payment Type")}`,
                                    field: "payment_type",
                                    render: (rowData) =>
                                      <>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Payment Type")}</div>
                                        {/* <div>
                                          {(rowData.payment_type)}
                                        </div> */}
                                        <div>
                                          {contract_type === "Loan" && rowData.payment_type === "Rent"
                                            ? "Payment"
                                            : rowData.payment_type}
                                        </div>
                                      </>,
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    },
                                    cellStyle: {
                                      textAlign: "left",
                                      fontSize: 12,
                                    },
                                  },
                                  {
                                    title: `${t("Payment Amount")}`,
                                    field: "amount",
                                    render: (rowData) =>
                                      <>
                                        <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                        >{t("Payment Amount")}</div>
                                        <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                          {Helper.Amount(rowData.amount)}
                                        </div></>,
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "right",
                                    },
                                    // cellStyle: {
                                    //   textAlign: "right",
                                    //   fontSize: 12,
                                    // },
                                  },
                                  {
                                    title: `${t("Start Date")}`,
                                    field: "start_date",
                                    render: (rowData) =>
                                      <>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Start Date")}</div>
                                        <div>
                                          {Helper.DateNormal(rowData.start_date)}</div></>,
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    },
                                    cellStyle: {
                                      textAlign: "left",
                                      fontSize: 12,
                                    },
                                  },
                                  {
                                    title: `${t("End Date")}`,
                                    field: "end_date",
                                    render: (rowData) =>
                                      <>
                                        <div className="d-xl-none tc d-md-none d-lg-none">{t("End Date")}</div>
                                        <div>
                                          {Helper.DateNormal(rowData.end_date)}</div></>,
                                    headerStyle: {
                                      verticalAlign: "inherit",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                    },
                                    cellStyle: {
                                      textAlign: "left",
                                      fontSize: 12,
                                    },
                                  },
                                ]}
                                data={itemsPayment}
                                options={{
                                  headerStyle: {
                                    backgroundColor: "white",
                                    color: "#245C7F",
                                    fontSize: 12,
                                  },
                                  rowStyle: (rowData, index) => {
                                    if (index % 2) {
                                      return { backgroundColor: "#fff" };
                                    }
                                  },
                                  sorting: true,
                                  search: false,
                                  toolbar: false,
                                  paging: true,
                                  pageSize: 3, // make initial page size
                                  emptyRowsWhenPaging: false, // To avoid of having empty rows
                                  pageSizeOptions: [3, 15, 20, 50],
                                  paginationType: "stepped",
                                  showFirstLastPageButtons: false,
                                  actionsColumnIndex: -1,
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <PaymentDetails id={state} contract={contract} setSelectedTab={setSelectedTab} setTransaction={setTransactionID} />

                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div
                      className="panel-content"
                      style={{ paddingLeft: "10px" }}
                    >
                      <ContractShortview contract={contract} customerPermission={customerPermission} TotalIncome={key.total_income} iir={iir} netinvest={key.amount_billed_not_paid} Loanpricipal={key.amount_billed_not_paid + key.total_capital_recovery} />
                      <div className="mt-3 pt-5">
                        {!assetid ? (
                          <AssetViewList
                            id={state}
                            contracttype={contract_type}
                          />
                        ) : (
                          <AssetView
                            asset_id={assetid}
                            id={state}
                            contracttype={contract_type}
                          ></AssetView>
                        )}
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="panel-content"
                      style={{ paddingLeft: "10px" }}
                    >
                      <ContractShortview contract={contract} customerPermission={customerPermission} netinvest={key.amount_billed_not_paid} Loanpricipal={key.amount_billed_not_paid + key.total_capital_recovery} />
                      <ViewAmortSchedules customerPermission={customerPermission} />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div
                      className="panel-content"
                      style={{ paddingLeft: "10px" }}
                    >
                      <ContractShortview contract={contract} customerPermission={customerPermission} TotalIncome={key.total_income} iir={iir} netinvest={key.amount_billed_not_paid} Loanpricipal={key.amount_billed_not_paid + key.total_capital_recovery} />

                      <div value={viewInvoice} className="pt-2 ml-2">
                        <button
                          type="button"
                          onClick={handelOnChange}
                          value="invoice"
                          className={
                            viewInvoice === "invoice"
                              ? "btn btn-primary active ms-auto mb-0"
                              : "btn btn-primary  ms-auto mb-0"
                          }
                          style={{
                            borderRadius: "0rem",
                            borderBottomLeftRadius: "1.5rem",
                            borderTopLeftRadius: "1.5rem",
                          }}
                        >
                          {t("Invoices")}

                        </button>
                        <button
                          type="button"
                          value="invoicewithdue"
                          className={
                            viewInvoice === "invoicewithdue"
                              ? "btn btn-primary active ms-auto mb-0"
                              : "btn btn-primary  ms-auto mb-0"
                          }
                          onClick={handelOnChange}
                          style={{
                            borderRadius: " 3.5rem",
                            borderBottomLeftRadius: "0rem",
                            borderTopLeftRadius: "0rem",
                          }}
                        >
                          {t("Invoices Due")}
                        </button>
                      </div>
                      {invoice && <Billing contractid={state} customerPermission={customerPermission} />}
                      {invoicewithdue && <InvoiceswithDue contractid={state} customerPermission={customerPermission} />}
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div
                      className="panel-content"
                      style={{ paddingLeft: "10px" }}
                    >
                      <ContractShortview contract={contract} customerPermission={customerPermission} iir={iir} TotalIncome={key.total_income} netinvest={key.amount_billed_not_paid} Loanpricipal={key.amount_billed_not_paid + key.total_capital_recovery} />

                      <TransactionContractview id={state} contract_type={contract_type} transactionNumber={transaction_id} setSelectedTab={setSelectedTab} setTransaction={setTransactionID} />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div
                      className="panel-content"
                      style={{ paddingLeft: "10px" }}
                    >
                      <ContractShortview contract={contract} customerPermission={customerPermission} iir={iir} TotalIncome={key.total_income} netinvest={key.amount_billed_not_paid} Loanpricipal={key.amount_billed_not_paid + key.total_capital_recovery} />

                      <TrialBalance id={state} contract_type={contract_type} setSelectedTab={setSelectedTab} setTransaction={setTransactionID} />
                    </div>
                  </TabPanel>
                  {
                    permissionsArray.includes('view_quoteheader') &&

                    <TabPanel>
                      <div
                        className="panel-content"
                        style={{ paddingLeft: "10px" }}
                      >
                        <ContractShortview contract={contract} customerPermission={customerPermission} TotalIncome={key.total_income} iir={iir} netinvest={key.amount_billed_not_paid} Loanpricipal={key.amount_billed_not_paid + key.total_capital_recovery} />
                        <div value={contract_modification} className="pt-2 ml-2">
                          {/* <div className="form-group row">
                          <div className="col-12  gap-5 d-flex align-items-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                value="ExtendTerm"
                                type="radio"
                                name="customer_type"
                                checked={contract_modification === "ExtendTerm"}
                                id="id_customer_type"
                                onChange={handelOnChangeContract}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                              >
                                Extend Term
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                value="PayoffQuote"
                                type="radio"
                                name="contract_modification"
                                checked={contract_modification === "PayoffQuote"}
                                id="id_customer_type"
                                onChange={handelOnChangeContract}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                              >
                                {t("Payoff Quote")}

                              </label>
                          </div>
                        </div>
                        </div> */}
                          <div className="radio-container">
                            {
                              contract_type === "Loan" ?
                                interestratetype === "Fixed" ? "" :
                                  <>
                                    <label
                                      className={`radio-label ${contract_modification === "InterestRateChange" ? "selected" : ""}`}
                                    >
                                      <input
                                        type="radio"
                                        name="contract_modification"
                                        value="InterestRateChange"
                                        checked={contract_modification === "InterestRateChange"}
                                        onChange={() => setContract_modification("InterestRateChange")}
                                      />
                                      {/* <span>Extend Term</span> */}
                                      <span>Interest Rate Change</span>
                                    </label>
                                  </>
                                :
                                <>

                                  <label
                                    className={`radio-label ${contract_modification === "ExtendTerm" ? "selected" : ""}`}
                                  >
                                    <input
                                      type="radio"
                                      name="contract_modification"
                                      value="ExtendTerm"
                                      checked={contract_modification === "ExtendTerm"}
                                      onChange={() => setContract_modification("ExtendTerm")}
                                    />
                                    {/* <span>Extend Term</span> */}
                                    <span>Payment Change</span>
                                  </label>
                                </>
                            }

                            {/* {contract_type === "Loan" && (
                              <label
                                className={`radio-label ${contract_modification === "DueDayChange" ? "selected" : ""}`}>

                                <input
                                  // type="button"
                                  type="radio"
                                  name="contract_modification"
                                  onClick={() => setContract_modification("DueDayChange")}
                                  checked={contract_modification === "DueDayChange"}
                                  value="DueDayChange"
                                // className={
                                //   contract_modification === "DueDayChange"
                                //     ? "btn btn-primary active"
                                //     : "btn btn-primary"
                                // }
                                />
                                Due Day Change

                              </label>
                            )} */}



                            <label
                              className={`radio-label ${contract_modification === "PayoffQuote" ? "selected" : ""}`}
                            >
                              <input
                                type="radio"
                                name="contract_modification"
                                value="PayoffQuote"
                                checked={contract_modification === "PayoffQuote"}
                                onChange={() => setContract_modification("PayoffQuote")}
                              />
                              <span>Payoff Quote</span>
                            </label>
                          </div>
                        </div>
                        {contract_modification === "ExtendTerm" &&
                          <div className="pt-2 ml-2">
                            <div className="card">
                              <div className="card-body">
                                <div className="form-group row">
                                  {/* <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <span className=" sub-title tc">
                                    {t("Term")}{" "}
                                    <Tooltip content={t("ContractTerm_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </span>
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                    <span className="party-detail-font">
                                      {contract.contract_term}
                                    </span>
                                  </div>
                                </div>
                                <div className="form-group row">
                                  <div className="col-md-6">
                                    <label className="col-form-label required">
                                      {t("New Term")}{" "}
                                      <Tooltip content={t("newterm_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <input
                                      placeholder={t("New Term")}
                                      className="form-control no-spinner"
                                      type="number"
                                      name="newterm"
                                      maxLength="200"
                                      id="id_term"
                                      value={newTerm}
                                      onChange={handleNewTermChange}
                                    />
                                    <div className="invalid-feedback">
                                      {error ? error : ''}
                                    </div>
                                  </div>
                                </div> */}
                                  {
                                    contract.contract_type === "Loan" ?
                                      ""
                                      // <LoanModification contractId={state} contractdetails={contract}/>
                                      :
                                      <ContractModification contract={state} contractdetails={contract} />
                                  }

                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        {
                          contract_modification === "InterestRateChange" &&
                          <LoanModification
                            contractId={state}
                            contractdetails={contract}
                            modificationType="InterestRateChange"
                          />
                        }
                        {contract_type === "Loan" &&
                          contract_modification === "DueDayChange" && (
                            <LoanModification
                              contractId={state}
                              contractdetails={contract}
                              modificationType="DueDayChange"
                            />
                          )}
                        {contract_modification === "PayoffQuote" && <Quote id={state} contract_number={contract_number} customerPermission={customerPermission} contract_type={contract_type} />}
                      </div>
                    </TabPanel>
                  }
                </Tabs>
              </div>
            </div>
          </div>
        ) : (
          <ContentLoader
            viewBox="0 0 400 160"
            backgroundColor="rgba(0,0,0,0.06)"
            foregroundColor="rgba(0,0,0,0.12)"
          >
            <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
            <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
            <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
            <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
            <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
            <rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
          </ContentLoader>
        )}
      </div>
    </>
  );
}

export default ContractView;
